import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToCreateDealSteps = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;

  const generalCreateDealSteps: StepType[] = [
    {
      content: 'Go to the Sales menu tab',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.MENU}"]`,
      position: 'right',
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 1000);
          },
          false,
        );
      },
      disableActions: true,
      styles: {
        arrow: (base) => ({
          ...base,
          visibility: 'hidden',
        }),
      },
    },
    {
      content: 'Then select Deals to view the Deals page',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 2000);
          },
          false,
        );
      },
      disableActions: false,
      styles: {
        arrow: (base) => ({
          ...base,
        }),
      },
    },
    {
      content: 'On the Deals page, click on the Create Deal button',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.FORM.CREATE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 2000);
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, top: '6%', marginLeft: 120 }),
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          type="create deal"
          // eslint-disable-next-line max-len
          content={`Fill out the details like deal name, pipeline, stage, amount, closed date, and deal owner.`}
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.FORM.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="Modal__Header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.FORM.FORM}"]`,
      ],
      disableActions: false,
      stepInteraction: false,
      position: 'right',
      styles: {
        popover: (base) => ({ ...base }),
      },
    },
    {
      content: 'Click Save and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.FORM.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
      styles: {
        popover: (base) => ({ ...base, marginLeft: -210 }),
      },
    },
  ];

  const showCreateDealSteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(generalCreateDealSteps);
      setIsOpen(true);
    }, 300);
  };

  return showCreateDealSteps;
};

export default useGetHowToCreateDealSteps;
